import { useSelector } from "react-redux";
import { GetIconBasedOnStatus } from "src/reusable/GetIconForNavBasedOnStatus";

const _nav = (id, type, pageStatuses) => {
  const currentFile = useSelector((state) => state?.old?.currentFile);

  const mortgageActingFor = currentFile?.fileOpen?.mortgageActingFor;
  const filesPrimaryClient = currentFile?.fileOpen?.filesPrimaryClient;

  const propertyIsCondo = currentFile?.property?.propertyIsCondo;
  const propertyPurchaseType = currentFile?.property?.propertyPurchaseType;
  const potl = currentFile?.property?.potl;

  const teranetData = currentFile?.TeranetAPIData;
  const performingTitleSearch = currentFile?.fileOpen?.performingTitleSearch;
  let nameForTitleSearchSideNav = "";
  if (performingTitleSearch === "no") {
    nameForTitleSearchSideNav = "Legal Description";
  } else nameForTitleSearchSideNav = "Perform Title Search";

  const navs = [
    {
      _tag: "CSidebarNavTitle",
      _children: ["Notes"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Memo",
      to: `/files/${type}/${id}/memos`,
      icon: "cil-bookmark",
    },
    // {
    //   _tag: "CSidebarNavDropdown",
    //   name: "Account Details",
    //   route: "/files/" + type + "/" + id + "/accountDetails",
    //   icon: "cil-user",
    //   _children: [
    //     // {
    //     //   _tag: "CSidebarNavItem",
    //     //   name: "Edit First Call",
    //     //   to: "/files/" + type + "/" + id + "/accountDetails/editFirstCall",
    //     // },
    //   ],
    // },

    {
      _tag: "CSidebarNavTitle",
      _children: ["Mortgage"],
    },

    {
      _tag: "CSidebarNavItem",
      name: "File Opening",
      to: `/files/${type}/${id}/fileOpen`,
      icon: GetIconBasedOnStatus({ page: "fileOpen", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Municipality",
      to: `/files/${type}/${id}/initial/Municipality`,
      icon: GetIconBasedOnStatus({ page: "Municipality", pageStatuses }),
    },

    ...(mortgageActingFor === "mortgagor" ||
    mortgageActingFor === "" ||
    mortgageActingFor === undefined ||
    (mortgageActingFor === "both" && filesPrimaryClient === "mortgagor")
      ? []
      : [
          {
            _tag: "CSidebarNavItem",
            name: "Mortgagee’s Solicitor",
            to: `/files/${type}/${id}/initial/mortgageesSolicitor`,
            icon: GetIconBasedOnStatus({ page: "mortgageesSolicitor", pageStatuses }),
          },
        ]),
    {
      _tag: "CSidebarNavItem",
      name: "Mortgagor",
      to: `/files/${type}/${id}/initial/mortgagor`,
      icon: GetIconBasedOnStatus({ page: "mortgagor", pageStatuses }),
    },
    ...(propertyIsCondo === "yes" ||
    propertyPurchaseType === "condominium" ||
    potl === "yes" ||
    propertyPurchaseType === "condominiumTownhouse"
      ? [
          {
            _tag: "CSidebarNavItem",
            name: "Condominium Details",
            to: `/files/${type}/${id}/initial/condominium`,
            icon: GetIconBasedOnStatus({ page: "condominium", pageStatuses }),
          },
        ]
      : []),
    {
      _tag: "CSidebarNavItem",
      name: "Property",
      to: `/files/${type}/${id}/initial/property`,
      icon: GetIconBasedOnStatus({ page: "property", pageStatuses }),
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "Title Search",
      route: `/files/${type}/${id}/initial`,
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: nameForTitleSearchSideNav,
          to: `/files/${type}/${id}/initial/teranet`,
          icon: GetIconBasedOnStatus({ page: "teranet", pageStatuses }),
        },
      ],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Existing Encumbrances",
      to: `/files/${type}/${id}/initial/existingEncumbrances`,
      icon: GetIconBasedOnStatus({ page: "existingEncumbrances", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "New Mortgage",
      to: `/files/${type}/${id}/initial/newMortgage`,
      icon: GetIconBasedOnStatus({ page: "newMortgage", pageStatuses }),
    },

    {
      _tag: "CSidebarNavItem",
      name: "Bills / Holdbacks",
      to: `/files/${type}/${id}/initial/BillsHoldbacks`,
      icon: GetIconBasedOnStatus({ page: "BillsHoldbacks", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Fire Insurance",
      to: `/files/${type}/${id}/closing/fireInsurance`,
      icon: GetIconBasedOnStatus({ page: "fireInsurance", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Title Insurance",
      to: `/files/${type}/${id}/closing/titleInsurance`,
      icon: GetIconBasedOnStatus({ page: "titleInsurance", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Executions Affidavits",
      to: `/files/${type}/${id}/closing/executionsAffidavits`,
      icon: GetIconBasedOnStatus({ page: "executionsAffidavits", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Undertakings",
      to: `/files/${type}/${id}/closing/undertakings`,
      icon: GetIconBasedOnStatus({ page: "undertakings", pageStatuses }),
    },
    // {
    //   _tag: "CSidebarNavItem",
    //   name: "Requisitions",
    //   to: "/files/" + type + "/" + id + "/closing/requisitions",
    // },
    // {
    //   _tag: "CSidebarNavItem",
    //   name: "Supplemental Tasks",
    //   to: "/files/" + type + "/" + id + "/closing/supplementalTasks",
    // },
    {
      _tag: "CSidebarNavItem",
      name: "Statement of Account",
      to: `/files/${type}/${id}/closing/statementOfAccount`,
      icon: GetIconBasedOnStatus({ page: "statementOfAccount", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Trust Ledger",
      to: `/files/${type}/${id}/closing/trustLedger`,
      icon: GetIconBasedOnStatus({ page: "trustLedger", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "E-Reg Drafts",
      to: `/files/${type}/${id}/documents/eRegistration`,
      icon: GetIconBasedOnStatus({ page: "eRegistration", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Upload Documents",
      to: `/files/${type}/${id}/documents/uploadPDFDocs`,
      icon: GetIconBasedOnStatus({ page: "uploadPDFDocs", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Generate Documents",
      to: `/files/${type}/${id}/documents/generateDocuments`,
      icon: GetIconBasedOnStatus({ page: "generateDocuments", pageStatuses }),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Finalized Documents",
      to: `/files/${type}/${id}/documents/fileDocumentsList`,
      icon: GetIconBasedOnStatus({ page: "fileDocumentsList", pageStatuses }),
    },

    {
      _tag: "CSidebarNavDivider",
    },
  ];

  const titleSearch = navs.find((e) => e.name === "Title Search");
  titleSearch._children.push({
    _tag: "CSidebarNavItem",
    name: "Perform Writ Search",
    to: `/files/${type}/${id}/initial/teranetWrits`,
    icon: GetIconBasedOnStatus({ page: "teranetWrits", pageStatuses }),
  });
  if (teranetData) {
    const keys = Object.keys(teranetData);
    keys.forEach((pin) => {
      titleSearch._children.push({
        _tag: "CSidebarNavItem",
        name: `Pin: ${pin}`,
        to: `/files/${type}/${id}/initial/teranetParcelRegister/${pin}`,
        icon: GetIconBasedOnStatus({ page: `teranetParcelRegister${pin}`, pageStatuses }),
      });
    });
  }

  return navs;
};

export default _nav;
